import PortraitPhotoModal from './PortraitPhotoModal.component';

export default PortraitPhotoModal;